// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"74ec22a5","132":"f74bb008","194":"9d624831","198":"affece83","352":"86652298","353":"b4c3e3da","409":"ad91e27b","585":"605a58f5","684":"2d7b728a","880":"d02ce1eb"}[chunkId] + ".chunk.js";
};